import { render, staticRenderFns } from "./communitySpacePersonManageList.vue?vue&type=template&id=6ca9675e&scoped=true"
import script from "./communitySpacePersonManageList.vue?vue&type=script&lang=js"
export * from "./communitySpacePersonManageList.vue?vue&type=script&lang=js"
import style0 from "./communitySpacePersonManageList.vue?vue&type=style&index=0&id=6ca9675e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca9675e",
  null
  
)

export default component.exports